<template>
  <el-popover
    placement="left"
    @show="handleShow">
    <div class="flex-common-style">
      <span class="ml15" style="flex-shrink: 0">当前二级域名：</span>
      <el-input class="ml15" v-model.trim="subDomain" placeholder="手动修改二级域名"></el-input>
      <el-button class="ml15" size="mini" type="primary" @click="submitDomainChange">确定切换</el-button>
    </div>
    <div slot="reference" id="api-btn" v-drag v-if="!isProduction">测试二级域名</div>
  </el-popover>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  computed: {
  },
  data () {
    return {
      subDomain: '',
      isProduction: process.env.NODE_ENV === 'production'
    }
  },
  methods: {
    submitDomainChange () {
      if (!this.subDomain) {
        return this.$message.warning('请输入测试二级域名')
      }
      Cookies.set('kf_admin_subDomain', this.subDomain)
      this.$store.commit('logout')
      location.reload()
    },
    handleShow () {
      this.subDomain = Cookies.get('kf_admin_subDomain')
    }
  }
}
</script>

<style lang="less" scoped>
#api-btn{
  position: fixed;
  top: 0;
  left: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px!important;
  background-color: #67C23A;
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
  z-index: 9999;
  font-size: 14px;
}
.store-select-radio label.el-radio{
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/DomainSelect.vue